import { Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';

type CartItemHeaderProps = {
  name: string;
  gradeInformation: string;
  lengthDisplayValue: string;
  isDeleting: boolean;
  onRemove: () => void;
};

export function CartItemHeader({
  name,
  gradeInformation,
  lengthDisplayValue,
  isDeleting,
  onRemove,
}: Readonly<CartItemHeaderProps>) {
  const { t } = useTranslation('cart');

  return (
    <div className="flex items-start justify-between mb-3">
      <div className="flex-1 min-w-0">
        <h4 className="text-neut-prim font-semibold mb-1 truncate">{name}</h4>
        <p className="text-sm text-neut-sec mb-1 ">
          {t('cart.cart_grade')}: {gradeInformation}
          <span className="ml-2 px-2 py-1 bg-success-100 text-success-600 rounded-md">
            {lengthDisplayValue}
          </span>
        </p>
      </div>

      <button
        type="button"
        aria-label="Remove"
        onClick={onRemove}
        className="p-2 hover:bg-neut-hover rounded-lg transition-colors shrink-0 ml-2 flex items-center justify-center cursor-pointer"
      >
        <Trash2
          className="w-4 h-4 text-neut-400 hover:text-error-500"
          aria-hidden="true"
        />{' '}
        {isDeleting ? (
          <span className="text-xs text-error-500 ml-1">
            {t('cart.deleting')}
          </span>
        ) : null}
      </button>
    </div>
  );
}
